import api from "./api";
import {
    PasswordResetEmailRequestDto,
    PasswordChangeViaTokenRequestDto,
    PasswordResetSmsRequestDto,
    PasswordVerifySmsRequestDto,
    PasswordVerifySmsEmailRequestDto,
    PasswordVerifyEmailRequestDto
} from "../shared/models/Verification.model";
import { AxiosResponse } from "axios";

const smsSendApi = async (phoneNumber: PasswordResetSmsRequestDto): Promise<AxiosResponse> => {
    return await api.post(`${process.env.REACT_APP_BACKEND_API}/password-reset/sms/send`, phoneNumber);
};

const smsVerifyApi = async (smsVerifyData: PasswordVerifySmsRequestDto): Promise<AxiosResponse> => {
    return await api.post(`${process.env.REACT_APP_BACKEND_API}/password-reset/sms/verify`, smsVerifyData);
};

const smsEmailVerifyApi = async (smsEmailVerifyData: PasswordVerifySmsEmailRequestDto): Promise<AxiosResponse> => {
    return await api.post(`${process.env.REACT_APP_BACKEND_API}/password-reset/sms-email/verify`, smsEmailVerifyData);
};

const emailSendApi = async (email: PasswordResetEmailRequestDto): Promise<AxiosResponse> => {
    return await api.post(`${process.env.REACT_APP_BACKEND_API}/password-reset/email/send`, email);
};

const emailVerifyApi = async (token: PasswordVerifyEmailRequestDto): Promise<AxiosResponse> => {
    return await api.post(`${process.env.REACT_APP_BACKEND_API}/password-reset/email/verify`, token);
};

const newPasswordSetApi = async (passwordSetData: PasswordChangeViaTokenRequestDto): Promise<AxiosResponse> => {
    return await api.post(`${process.env.REACT_APP_BACKEND_API}/password-reset/set-new-password`, passwordSetData);
};

export {
    smsSendApi,
    emailVerifyApi,
    emailSendApi,
    smsVerifyApi,
    smsEmailVerifyApi,
    newPasswordSetApi
}
